<template>
<cAgentDeposit :isViewOnly='true'/>
  
</template>

<script>
import { addClassToBody,removeClassBody } from "../../util/util";

import cAgentDeposit from './../../components/postpaid/cAgentDeposit'
import {
  PATHNAME,
  COMPONENT_NAME,
  SECTOR_TYPE,
  PRICING_VALUE,
  DEFAULT_DROPDOWN_STATUS,
  POSTPAID_STATEMENT_STATUS,
  POSTPAID_TYPE
} from "./../../util/constants";
export default {


name:COMPONENT_NAME.AGENT_VIEW_STATEMENTS,
components:{
  cAgentDeposit
},
beforeCreate() {    
   addClassToBody(COMPONENT_NAME.AGENT_VIEW_STATEMENTS);
  },
  
   beforeDestroy() {
       removeClassBody();
    },
}
</script>

<style>

</style>